import copyCssTextForBlock from './copy-css-text-for-block';
import copyCustomColorsBetweenCssRules from './copy-custom-colors-between-css-rules';
import createCustomTextColorStylesheet from './create-custom-text-color-stylesheet';
import createEmptyCssRule from './create-empty-css-rule';
import getCssRootVariablesMap from './get-css-root-variables-map';
import getCssTextFromCssVariablesMap from './get-css-text-from-css-variables-map';
import getCssVariableNameByColor from './get-css-variable-name-by-color';
import getCssVariablesMap from './get-css-variables-map';
import getCustomColorFromTextColor from './get-custom-color-from-text-color';
import getCustomTextColorsStylesheet from './get-custom-text-color-stylesheet';
import getElementCustomColorVariables from './get-element-custom-color-variables';
import getCssRuleBySelector from './get-css-rule-by-selector';
import reloadCustomColorStylesheet from './reload-custom-color-stylesheet';
import setRuleForSelector from './set-rule-for-selector';
import updateCustomColorStylesheetInGlobal from './update-custom-color-stylesheet-in-global';
import createRootVariableName from './create-root-variable-name';
import createCssTextRule from './create-css-text-rule';
import getTextVariableName from './get-text-variable-name';
import getCssTextRule from './get-css-text-rule';

export default {
  copyCssTextForBlock,
  copyCustomColorsBetweenCssRules,
  createCustomTextColorStylesheet,
  createEmptyCssRule,
  getCssRootVariablesMap,
  getCssTextFromCssVariablesMap,
  getCssVariableNameByColor,
  getCssVariablesMap,
  getCustomColorFromTextColor,
  getCustomTextColorsStylesheet,
  getElementCustomColorVariables,
  getCssRuleBySelector,
  reloadCustomColorStylesheet,
  setRuleForSelector,
  updateCustomColorStylesheetInGlobal,
  createRootVariableName,
  createCssTextRule,
  getTextVariableName,
  getCssTextRule,
};
